import { lazy } from "react";

export const MyEventsPageAsync = lazy(() => import("./MyEventsPage").then((m) => ({ default: m.MyEventsPage })));
